module.exports = __webpack_public_path__ + "img/lan.96c801b9.png";